function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "65.6464047%",
  y1: "-21.9472249%",
  x2: "43.4351179%",
  y2: "113.66984%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#32C5FF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B620E0",
  offset: "51.2583893%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F7B500",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50.6362415%",
  y1: "-22.201328%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-2"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#000000",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFFFF",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "55.3400007%",
  y1: "35.7864556%",
  x2: "50%",
  y2: "100%",
  id: "linearGradient-3"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#000000",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFFFF",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "url(#linearGradient-1)",
  x: 0,
  y: 0,
  width: 320,
  height: 768
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: 38,
  y: 259,
  width: 242,
  height: 59,
  rx: 6
});

var _ref5 = /*#__PURE__*/React.createElement("text", {
  id: "VRIENDEN-18+",
  fontFamily: "AvenirNext-Bold, Avenir Next",
  fontSize: 18,
  fontWeight: "bold",
  fill: "#75318C"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 92.549,
  y: 296
}, "VRIENDEN 18+"));

var _ref6 = /*#__PURE__*/React.createElement("polygon", {
  id: "Triangle",
  fill: "#6D1C6C",
  transform: "translate(260.000000, 290.500000) rotate(-180.000000) translate(-260.000000, -290.500000) ",
  points: "260 287 265 294 255 294"
});

function SvgTriangleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "7px",
    viewBox: "0 0 10 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Triangle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Get-started",
    transform: "translate(-255.000000, -287.000000)"
  }, _ref3, /*#__PURE__*/React.createElement("path", {
    d: "M0,256.46875 C4.20572917,152.356771 57.5390625,108.291667 160,124.273438 C262.460938,140.255208 315.794271,89.4973958 320,-28 L320,609.71875 L0,609.71875 L0,256.46875 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.113885789
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26325641e-13,578.570313 C95.125,354.203125 109.335938,565.988281 205.464844,506.089844 C269.550781,466.157552 307.729167,371.460937 320,222 L320,931.820312 L4.26325641e-13,931.820312 C-63.4166667,845.898438 -63.4166667,728.148438 4.26325641e-13,578.570313 Z",
    id: "Path-Copy",
    fill: "url(#linearGradient-3)",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.0334588914
  }), _ref4, _ref5, _ref6)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleIcon);
export default __webpack_public_path__ + "static/media/triangle-icon.08f51e84.svg";
export { ForwardRef as ReactComponent };